import { Component, NgZone, OnInit } from "@angular/core";
import { AuthService } from "src/app/services/auth/auth.service";
import { LoaderService } from "src/app/services/interceptor/loader.service";
import { MainService } from "src/app/services/main/main.service";
import { PersonaService } from "src/app/services/persona/persona.service";
import { PlaidService } from "src/app/services/plaid/plaid.service";
import { StripeService } from 'src/app/services/stripe/stripe.service';
import { getUserProfile, getUserProfiles } from 'src/app/core/session';

@Component({
  selector: "app-businessverification",
  templateUrl: "./business-verification.component.html",
  styleUrls: ["./business-verification.component.scss"],
})
export class BusinessverificationComponent implements OnInit {
  payment_option: any = { cardName: '' };
  new_address: any = {};
  verifyDocs: any;
  submit_doc_disable: Boolean = true;
  notes: any;
  docsLength: any;
  profile: any = {
    auth_bank_status: 'reauthenticate',
    auth_card: 0,
    auth_doc_uploaded: 0,
    is_auth_card_added: 0
  };
  moreDocuments: any = [];
  documents_uploaded = 0;
  userProfileData: any;
  cookie = this.mainService.gt_get_cookie('googtrans').split('/').pop();
  constructor(
    public loaderService: LoaderService,
    public mainService: MainService,
    private authService: AuthService,
    private zone: NgZone,
    public plaidService: PlaidService,
    private stripe: StripeService,
    private persona: PersonaService,
  ) { }

  ngOnInit() {
    this.authService.getProfileData$.subscribe((data) => {
      this.profile = data;
      this.verifyDocs = data.auth_docs;
      this.docsLength = data.auth_docs_limit;
    })
    //this.getBankInfo();
    if (this.profile.is_auth_card_added !== 1) {
      setTimeout(() => {
        this.mountCard();
      }, 100);
    }

    this.userProfileData = localStorage.getItem('userProfileData') && getUserProfiles() && getUserProfile() && getUserProfile();

    this.plaidService.plaid_success_subject.subscribe((res: any) => {
      if (res == 1) {
        this.authService.getbankDetails();
        this.getOtherProfile();
        setTimeout(() => {
          this.getBankInfo();
        }, 2000);
      }
    })
  }

  async mountCard() {
    const data = {
      isMountAddress: false,
      doctor_id: this.userProfileData.doctor_id,
    };
    await this.stripe.createStripeElement(data);
  }

  getBankInfo() {
    this.profile = this.authService.getProfileData;
    this.verifyDocs = this.authService.getProfileData.auth_docs;
    this.docsLength = this.authService.getProfileData.auth_docs_limit;
  }

  getStripe() {
    let data;
    data = document.getElementsByClassName('.stripe-card') && document.getElementsByClassName('.stripe-card')[0];
    if (data === null || data === undefined) {
      this.mainService.stripe_element.mount('#' + 'add_card');
    }

    let stripe_card = document.querySelector('.stripe-card')
    if (stripe_card !== null) {
      stripe_card.classList.add('br-12');
      setTimeout(() => {
        stripe_card.getElementsByTagName('div')[0].style.top = "6px"
      }, 1000)
    }

  }

  async getOtherProfile() {
    await this.authService.accessTokenLogin();
  }

  uploadFile(event, docs) {
    try {
      if((docs.is_approved == 1 && docs.is_expired == 1) || (docs.is_approved == 0 && docs.is_expired == 1) || (docs.show_reupload == 1)) {
        this.deleteDocument(docs.id,0);
      }
      if (event && event.target && event.target.files && event.target.files[0] && (event.target.files[0].size > 10000000)) {
        this.mainService.customPopups('File size is too large, you can upload maximum 10MB file.', 1);
        event.target.value = '';
        return false;
      };

      if (event && event.target && event.target.files && event.target.files[0] && (event.target.files[0].type != "image/png" && event.target.files[0].type != 'application/pdf' && event.target.files[0].type != 'image/jpeg' && event.target.files[0].type != 'image/jpg')) {
        this.mainService.customPopups('File type not supported. Please upload a valid file(.pdf, .jpg, .jpeg, .png).', 1);
        event.target.value = '';
        return false;
      }

      let formdata = new FormData();
      let access_token = localStorage.getItem('token');
      formdata.append('access_token', access_token);
      formdata.append('type', event.target.name);
      formdata.append('pp_docs', event && event.target && event.target.files && event.target.files[0]);
      if (docs && docs.id) {
        formdata.append('doc_id', docs.id);
      }
      this.mainService
        .uploadApi(formdata, 'upload_buss_docs', true)
        .subscribe((data: any) => {
          if (data && data.is_error == 0) {
            this.documents_uploaded = 1;
            this.submit_doc_disable = false;
            this.authService.getbankDetails();
            setTimeout(() => {
              this.getBankInfo();
            }, 2000);
          }
        });
    } catch (error) {
      console.log(error);
    }
  }

  sendCardDetails() {
    if (this.payment_option.cardName == '') {
      this.mainService.customPopups("Card holder name should not be empty.", 1)
      return;
    }

    this.loaderService.show();
    setTimeout(async () => {
      const response = await this.stripe.stripe.confirmCardSetup(
        this.stripe.setup_intent_secret.setup_intent_secret,
        {
          payment_method: {
            card: this.stripe.paymentElement,
            billing_details: {
              name: this.payment_option.cardName
            },
          },
        }
      );
      if (response.error) {
        this.mainService.customPopups(response.error.message, 1)
        this.loaderService.hide();
        return;
      }
      if (response.setupIntent && response.setupIntent.status === "succeeded") {
        let token = localStorage.getItem('token');
        this.userProfileData = localStorage.getItem('userProfileData') && getUserProfiles() && getUserProfile() && getUserProfile();
        let formdata = {
          access_token: token,
          doctor_id: this.userProfileData.doctor_id,
          card_desired_amount: 0,
          bank_desired_amount: 0,
          seti_id: response.setupIntent.id,
        };
        this.mainService
          .api(formdata, 'add_business_auth_card', true)
          .subscribe(async (data: any) => {
            if (data.is_error == 0) {
              this.authService.getbankDetails();
              setTimeout(() => {
                this.getBankInfo();
              }, 2000);
            }
          });
        this.loaderService.hide();
      }
    }, 1000);
  }

  deleteDocument(data,showPopup = 1) {
    try {
      let formdata = new FormData();
      let access_token = localStorage.getItem('token');

      formdata.append('access_token', access_token);
      formdata.append('id', data);

      this.mainService
        .uploadApi({ access_token, id: data }, 'delete_buss_docs', showPopup == 1 ? true : false)
        .subscribe((data: any) => {
          if (data && data.is_error == 0) {
            this.notes = '';
            if(showPopup) {
              this.authService.getbankDetails();
              setTimeout(() => {
                this.getBankInfo();
              }, 2000);
            }
          }
        });
    } catch (error) {
      console.log(error);
    }
  }

  handleInput(event) {
    if (event.target.selectionStart === 0 && event.code === 'Space') {
      event.preventDefault();
    }
  }

  addMoreDocument() {
    this.moreDocuments.push({
      file_name: '',
      file: '',
      error: false
    })
  }

  getFormvalues(event, index) {
    try {
      if (event && event.target && event.target.files && event.target.files[0] && (event.target.files[0].size > 10000000)) {
        this.mainService.customPopups('File size is too large, you can upload maximum 10MB file.', 1);
        event.target.value = '';
        return false;
      };

      if (event && event.target && event.target.files && event.target.files[0] && (event.target.files[0].type != "image/png" && event.target.files[0].type != 'application/pdf' && event.target.files[0].type != 'image/jpeg' && event.target.files[0].type != 'image/jpg')) {
        this.mainService.customPopups('File type not supported. Please upload a valid file(.pdf, .jpg, .jpeg, .png).', 1);
        event.target.value = '';
        return false;
      }

      this.moreDocuments[index].file = event.target.files[0];
      let formdata = new FormData();
      let access_token = localStorage.getItem('token');

      formdata.append('access_token', access_token);
      formdata.append('type', undefined);
      formdata.append('pp_docs', event.target.files[0]);
      formdata.append('doc_name', event.target.name);

      this.mainService
        .uploadApi(formdata, 'upload_buss_docs', true)
        .subscribe((data: any) => {
          if (data && data.is_error == 0) {
            this.documents_uploaded = 1;
            this.moreDocuments.length = 0;
            this.mainService.customPopups('Document uploaded successfully', 0);
            this.authService.getbankDetails();
            setTimeout(() => {
              this.getBankInfo();
            }, 2000)
          }
        });
    } catch (error) {
      console.log(error);
    }
  }

  namchange(e, i) {
    this.moreDocuments[0].file_name = e.target.value.trim()
    if (e.target.value.trim() == "") {
      this.moreDocuments[0].error = true;
    }
    else {
      this.moreDocuments[0].error = false;
    }
  }

  addBankAccount() {
    // let user_details = this.userProfileData;
    // let doctorId = user_details.doctor_id;
    // let plaid_access_token = '';
    // if (user_details && user_details.auth_bank_status == 'reauthenticate' && user_details.auth_bank && user_details.auth_bank[0] && user_details.auth_bank[0].plaid_access_token) {
    //   plaid_access_token = user_details.auth_bank[0].plaid_access_token;
    // }
    // this.plaidService.createLinkTokenPlaid({ doctor_id: doctorId, plaid_access_token: plaid_access_token, status: this.profile.auth_bank_status })

    this.persona.openKYBPersona();

  }

  saveNote() {
    let token = localStorage.getItem('token');
    let doctor_id = this.userProfileData.doctor_id
    let formData = {};
    formData['access_token'] = token;
    formData['doctor_id'] = doctor_id;
    formData['notes'] = this.notes;
    this.mainService
      .uploadApi(formData, 'create_internal_ticket_docs', true)
      .subscribe((data: any) => {
        if (data && data.is_error == 0) {
          this.documents_uploaded = 0;
          this.notes = '';
          this.mainService.customPopups("Data saved successfully", 0);
        }
      })
  }

  checkExpired(docs) {
    console.log(docs)
  }

  deleteDocumentandUpload(event, docs) {
    try {
      let formdata = new FormData();
      let access_token = localStorage.getItem('token');

      formdata.append('access_token', access_token);
      formdata.append('id', docs.id);

      this.mainService
        .uploadApi({ access_token, id: docs.id }, 'delete_buss_docs', false)
        .subscribe((data: any) => {
          if (data && data.is_error == 0) {
            this.notes = '';
            this.uploadFile(event, docs)
          }
        });
    } catch (error) {
      console.log(error);
    }
  }


  getCardBrandImage(card): string {
    if (card) {
      let brand = (card.brand || card.card.brand).toLowerCase();
      let allowedBrands = ['mastercard', 'discover', 'jcb', 'visa', 'american express', "unionpay", 'diners', 'amex'];
      if (brand === 'american express' || brand == 'amex') {
        return `assets/img/svg/card-type/American Express.svg`;
      }
      if (brand === 'mastercard') {
        return `assets/img/svg/card-type/MasterCard.svg`;
      }
      if (brand === 'unionpay') {
        return `assets/img/svg/card-type/UnionPay.svg`;
      }
      if (brand === 'diners') {
        return `assets/img/svg/card-type/Diners Club.svg`;
      }
      if (brand === 'jcb') {
        return `assets/img/svg/card-type/JCB.svg`;
      }
      return brand && allowedBrands.includes(brand)
        ? `assets/img/svg/card-type/${this.capitalizeFirstLetter(brand)}.svg`
        : 'assets/img/svg/card-type/no_card.svg';
    }
  }
  capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

}
